import Api from '@/api/Api'
import DownloadApi from '@/api/DownloadApi'
import toast from '@/mixins/toast'
import moment from 'moment'
import router from '@/router'

export default {

    fetchTotalRows (payload) {
      return Api().get('/notifications/totalrows').then( (response) => {
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }
                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    fetchTotalRowsByAgency (payload) {
      return Api().get('/notifications/agency/'+ payload +'/totalrows').then( (response) => {
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }

                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    addNotification (payload) {
        return Api().post('/notification', payload).then( (response) => {
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }


                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    deleteNotification (payload) {
        return Api().delete('/notification/'+payload).then( (response) => {
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }

                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    updateNotification (payload) {
        return Api().put('/notification', payload).then( (response) => {
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }


                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },
    updateNotificationStatus (payload) {
        return Api().put('/notification/status', payload).then( (response) => {
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }


                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    updateNotificationRequest (payload) {
        return Api().put('/notification/request', payload).then( (response) => {
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }

                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    updateNotificationRequestCentcom (payload) {
        return Api().put('/notification/centcom', payload).then( (response) => {
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }


                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    copyNotificationRequest (payload) {
        return Api().post('/notifications/copy', payload).then( (response) => {
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }

                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    fetchAll () {
        return Api().get('/notifications').then( (response) => {                
                return response.data;
            })
            .catch( error => {
                console.log(error)
                if (error.response) {
                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      } 
                      else {
                        toast.error( error.response.message, "Error")
                      }
                    } else if (error.request) {
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },
    fetchByUser (id) {
        return Api().get('/notifications/user/'+ id).then( (response) => {
                return response.data;
            })
            .catch( error => {
                console.log(error)
                if (error.response) {
                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      } 
                      else {
                        toast.error( error.response.message, "Error")
                      }
                    } else if (error.request) {
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },
    fetchByAgency (id) {
        return Api().get('/notifications/agency/'+ id).then( (response) => {
                return response.data;
            })
            .catch( error => {
                console.log(error)
                if (error.response) {
                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }
                      else {
                        toast.error( error.response.message, "Error")
                      }
                    } else if (error.request) {
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },
    fetchByNotificationId (id) {
        return Api().get('/notifications/'+ id).then( (response) => {
                return response.data[0];
            })
            .catch( error => {
                console.log(error)
                if (error.response) {
                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }
                      else {
                        toast.error( error.response.message, "Error")
                      }
                    } else if (error.request) {
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },
    fetchByNotificationIdAndRequestTypeId (id, requestTypeId) {
        return Api().get('/notifications/'+ id +"/"+ requestTypeId).then( (response) => {
                return response.data[0];
            })
            .catch( error => {
                console.log(error)
                if (error.response) {
                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }
                      else {
                        toast.error( error.response.message, "Error")
                      }
                    } else if (error.request) {
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    // fetchByNVNumberAndRequestTypeId(id, requestTypeId) {
    //     return Api().get('/notifications/nv/'+ id +"/"+ requestTypeId).then( (response) => {
    //             return response.data[0];
    //         })
    //         .catch( error => {
    //             console.log(error)
    //             if (error.response) {
    //                   toast.error( error.response.message, "Error")
    //                 } else if (error.request) {
    //                   console.log(error.request)
    //                   toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
    //                 } else {
    //                   // Something happened in setting up the request that triggered an Error
    //                   console.log('Error', error.message);
    //                 }
    //         })
    // },

    download (notificationId, requestTypeId) {
        return DownloadApi().get('/download/'+ notificationId +'/'+ requestTypeId, {responseType: 'arraybuffer'}).then( (response) => {
               
               const currentDateTime = moment(new Date()).format('YYYYMMDDHHmm') 
               const filename = 'HNS-'+ currentDateTime +".zip"
               const url = window.URL.createObjectURL(new Blob([response.data]));
               const link = document.createElement('a');
               link.href = url;
               link.setAttribute('download', filename); 
               document.body.appendChild(link);
               link.click();              
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }
                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    sendReportToEmail (notificationId, requestTypeId) {
        return Api().get('/download/email/'+ notificationId +'/'+ requestTypeId).then( (response) => {               
               return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }
                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

     notify (payload) {
        return Api().post('/notify', payload).then( (response) => {
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }

                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    notifyWithAttachment (notificationId, requestTypeId,  payload) {
        return Api().post('/notify/'+ notificationId+'/'+requestTypeId, payload).then( (response) => {
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }

                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    generateNextNVNumber (payload) {
        return Api().get('/notification/nextnv/'+ payload).then( (response) => {
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }
                      
                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    fetchDashboardStatistics (id) {
         
        return Api().get('/notifications/statistics/'+ id).then( (response) => {
                return response.data[0];
            })
            .catch( error => {
                console.log(error)
                if (error.response) {
                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }
                      toast.error( error.response.message, "Error")
                    } else if (error.request) {
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    fetchTrackingSheet (id) {
         
        return Api().get('/tracking_sheet').then( (response) => {
                return response.data[0];
            })
            .catch( error => {
                console.log(error)
                if (error.response) {
                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }
                      toast.error( error.response.message, "Error")
                    } else if (error.request) {
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    }
}


// WEBPACK FOOTER //
// ./src/api/NotificationService.js